import React from 'react'
import { CallToAction } from 'components/CallToAction'

export const TracksCTA = () => {
    return (
        <>
            <br />
            <p className="relative z-10 mb-0 px-4 text-center text-sm font-bold md:text-lg">
                Want more tips? Get curated courses and lessons in iCloudReady Academy!
            </p>
            <div className="flex flex-col items-center justify-center gap-2 md:flex-row xl:gap-4">
                <CallToAction width="56" to="/academy">
                    Try iCloudReady Academy
                </CallToAction>
                <CallToAction type="outline" width="56" to="/tutorials">
                    View all tutorials
                </CallToAction>
            </div>
            <br />
        </>
    )
}
